import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jiraProjectCreateStepLabel: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.jira-project-create-step-label',
		defaultMessage: 'Create business project',
		description: 'Label for project create step in progress tracker',
	},
	projectCreateStepLabel: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.project-create-step-label',
		defaultMessage: 'Create project',
		description: 'Label for project create step in progress tracker',
	},
	reviewStepLabel: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.review-step-label',
		defaultMessage: 'Review details',
		description: 'Label for review field mapping step in progress tracker',
	},
	importInProgressStepLabel: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.import-in-progress-step-label',
		defaultMessage: 'Import data',
		description: 'Label for import in progress step in progress tracker',
	},
	uploadCsv: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.upload-csv',
		defaultMessage: 'Upload CSV',
		description: 'Label for upload CSV step in progress tracker',
	},
	setupProject: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.setup-project',
		defaultMessage: 'Set up project',
		description: 'Label for setup project step in progress tracker',
	},
	mapFields: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.map-fields',
		defaultMessage: 'Map fields',
		description: 'Label for map fields step in progress tracker',
	},
	usersMapping: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.users-mapping',
		defaultMessage: 'Move users',
		description: 'Label for users step in progress tracker',
	},
	review: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.review',
		defaultMessage: 'Review details',
		description: 'Label for review step in progress tracker',
	},
});
